import React from 'react';
import { VictoryAxis } from 'victory';

// get max value of an array
export const getMaxValue = (pData: any[], pField: any, pMode: string) => {  
  const values: number[] = pData.map((v) => {
    if (v[pField] !== 0 || v[pField] !== null) {
      return v[pField];
    }
  });
  if(pMode === 'positive') {
    return Math.max(...values);
  } else {
    return Math.min(...values);
  }
};

export const YAxis = (props?: any, pTickLabelsFontSize?: number) => {
  const label = props?.axisYLabel !== undefined ? props?.axisYLabel : '';
  return (
    <VictoryAxis
      dependentAxis
      standalone={false}
      label={label}
      style={{
        axis: {
          stroke: 'grey',
          strokeWidth: 2,
        },
        axisLabel: {
          padding: 40,
          fontSize: 9,
        },
        grid: {
          stroke: '#818e99',
          strokeWidth: 0.5,
          strokeDasharray: '2,4',
        },
        tickLabels: {
          fontWeight: 400,
          fontSize: pTickLabelsFontSize === undefined ? 10 : pTickLabelsFontSize,
        },
      }}
      tickFormat={(t) => `${t}`}
    />
  );
};

export const XAxis = (props?: any) => {
  return (
    <VictoryAxis
      standalone={false}
      style={{
        axis: {
          strokeWidth: 1,
        },
        axisLabel: {
          padding: 35,
          fontSize: 9,
        },
        ticks: { stroke: 'grey', size: 4 },
        tickLabels: {
          fontSize: 7,
        },
      }}
      tickFormat={(date) => {
        return date.toLocaleString('default', {
          day: 'numeric',
          month: 'short',
        });
      }}
    />
  );
};

export const PluvioAxis = (props: any, pOffsetX: number, pAddDataMax: number, pColor?: string, pTickLabelsFontSize?: number) => {
  const label = props?.axisYLabelPluvio !== undefined ? props?.axisYLabelPluvio : '';
  return (
    <VictoryAxis
      dependentAxis
      standalone={false}
      label={label}
      offsetX={pOffsetX}
      style={{
        axis: {
          stroke: 'grey',
          strokeWidth: 2,
        },
        axisLabel: {
          fill: pColor === undefined ? '#63D1B5' : pColor,
          padding: -50,
          fontSize: 9,
        },
        grid: {
          stroke: '#818e99',
          strokeWidth: 0.5,
          strokeDasharray: '2,4',
        },
        tickLabels: {
          fill: pColor === undefined ? '#63D1B5' : pColor,
          fontWeight: 400,
          fontSize: pTickLabelsFontSize === undefined ? 9 : pTickLabelsFontSize,
          padding: -30,
        },
      }}
      tickFormat={(datum) => {
        if (pAddDataMax === null || pAddDataMax === 0) {
          return datum;
        } else if (props.dataMaxValue === null || props.dataMaxValue === 0) {
          return datum;
        } else {
          return Math.round(
            (datum * pAddDataMax) / props.dataMaxValue
          );
        }
      }}
    />
  );
};
